import { Avatar, Button, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleX, WhiteArrowRight } from 'Images';
import { stopPropagationAccessibilityBehavior } from 'Utils/accessibilityOnKeyDown';

interface IResetFilterButtons {
  resetCallback: Function;
  filterCallback?: Function;
  sx?: SxProps;
}

export const ResetFilterButtons = ({
  resetCallback,
  filterCallback,
  sx,
}: IResetFilterButtons) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  return (
    <Stack
      direction='row'
      justifyContent='space-evenly'
      alignItems='center'
      sx={{
        position: 'absolute',
        bottom: 0,
        bgcolor: '#FFF',
        p: '12px 0',
        zIndex: 1,
        width: 'calc(100% - 5px)',
        ...sx,
      }}
      onKeyDown={stopPropagationAccessibilityBehavior}
    >
      <Button
        onClick={() => resetCallback()}
        sx={{
          ':hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
          },
        }}
      >
        <Avatar alt='' src={PurpleX} sx={{ width: '24px', height: '24px' }} />
        <Typography variant='body4'>{dictionary.resetFilterChoice}</Typography>
      </Button>
      {filterCallback && (
        <Button
          onClick={() => filterCallback()}
          sx={{
            bgcolor: 'primary.shade_400',
            color: '#FFF',
            ':hover': {
              cursor: 'pointer',
              bgcolor: 'primary.shade_500',
            },
          }}
        >
          <Typography variant='body4'>{dictionary.filterResults}</Typography>
          <Avatar
            alt=''
            src={WhiteArrowRight}
            sx={{ width: '20px', height: '20px', transform: 'rotateY(180deg)' }}
          />
        </Button>
      )}
    </Stack>
  );
};
